
const backendURL = import.meta.env.VITE_API_URL;


export const requestPasswordReset = async (data) => {
    try {
        const response = await fetch(`${backendURL}/password-recovery/request-reset`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error("Error al solicitar el restablecimiento de contraseña");
        }

        return response.json();
    } catch (error) {
        console.error("Error en la solicitud de restablecimiento de contraseña:", error);
        throw error;
    }
};

export const resetPasswordRequested = async (data) => {
    try {
        const response = await fetch(`${backendURL}/password-recovery/reset`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });

        if (!response.ok) {
            throw new Error("Error al solicitar el restablecimiento de contraseña");
        }

        return response.json();
    } catch (error) {
        console.error("Error en la solicitud de restablecimiento de contraseña:", error);
        throw error;
    }
};

export const checkToken = async (token) => {
    try {
        const response = await fetch(`${backendURL}/password-recovery/verify-token/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token }),
        });

        if (!response.ok) {
            throw new Error("Error al verificar el token");
        }

        return response.json();
    } catch (error) {
        console.error("Error en la verificación del token:", error);
        throw error;
    }
};